import React, { memo } from 'react';
import { Link } from 'react-router-dom';

export default memo(function Default() {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70vh',
    backgroundColor: 'var(--theme-color-canvas)',
    padding: 'var(--theme-spacing-xl)',
    textAlign: 'center',
  };

  const headingStyle = {
    fontFamily: 'var(--theme-font-family-display)',
    fontSize: '80px',
    fontWeight: 700,
    color: 'var(--theme-color-primary)',
    margin: 0,
    lineHeight: 1,
  };

  const textStyle = {
    fontFamily: 'var(--theme-font-family-body)',
    color: 'var(--theme-color-body)',
    marginTop: 'var(--theme-spacing-md)',
    marginBottom: 'var(--theme-spacing-xl)',
    fontSize: '18px',
  };

  return (
    <div style={containerStyle}>
      <div id="default">
        <h1 style={headingStyle}>404</h1>
        <p style={textStyle}>Page not found</p>
        <Link to="/home" className="btn btn-primary" style={{ padding: 'var(--theme-spacing-md) var(--theme-spacing-xl)', textDecoration: 'none' }}>
          Go Home
        </Link>
      </div>
    </div>
  );
});

